import React from 'react';
import { observer } from 'mobx-react';
import CollectionView from 'lib/collection/collection-view';
import ImagesPreviewItem from './images-preview-item';
import { ObservableArray } from 'mobx/lib/types/observablearray';

interface Data {
    remove: (data: any) => Promise<any>;
    fields: ObservableArray<any> & any[];
    key: string | number;
    file: File | any;
    progress: number;
    uploading: boolean;
    error: any;
    upload: (event?: any) => void | Promise<any>;
}

interface Props {
    field: {
        data: Data;
    };
    thumbnail: React.DetailedReactHTMLElement<any, HTMLElement>;
    onCancel: (result: any) => void;
    onCancelError: (err: any) => void;
}

class ImagesPreview extends React.Component<Props> {
    onRemove = (data: Data) => () => {
        this.props.field.data
            .remove(data)
            .then(result => {
                if (this.props.onCancel) {
                    this.props.onCancel(result);
                }
            })
            .catch(err => {
                if (this.props.onCancelError) {
                    this.props.onCancelError(err);
                }
            });

        return null;
    };

    element = (data: Data) => {
        const { key, file, progress, uploading, error, upload } = data;
        let name = '';
        if (file) {
            ({ name } = file);
        }

        return (
            <ImagesPreviewItem
                key={key}
                thumbnail={React.cloneElement(this.props.thumbnail, { ...data })}
                name={name}
                progress={progress}
                uploading={uploading}
                error={error}
                onRemove={this.onRemove(data)}
                onRetry={upload}
            />
        );
    };

    move = (from: number, to: number) => {
        const items = this.props.field.data.fields.slice();
        const value = items[from];

        items.splice(from, 1);
        items.splice(to, 0, value);

        this.props.field.data.fields.replace(items);
    };

    itemKey = ({ key }: { key: string | number }) => key;
    isDraggable = () => this.props.field.data.fields.length > 1;

    render() {
        const {
            field: { data },
        } = this.props;

        return (
            <CollectionView
                items={data.fields}
                element={this.element}
                move={this.move}
                itemKey={this.itemKey}
                isDraggable={this.isDraggable}
                height={107.5}
                width={107.5}
                center={false}
            />
        );
    }
}

export default observer(ImagesPreview);
